export default "__VITE_ASSET__Cqe2SyWi__"